import { Component, EventEmitter, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthServiceService } from '../../../service/auth-service.service';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http'; 
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { HostListener } from '@angular/core';
import { CommonServiceService } from '../../../service/common-service.service';
@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class NavbarComponent {


  activeLink: string = '';

  setActiveLink(link: string) {
    this.activeLink = link;
  }


  userId: string | null = null;
  UserName: string | null = null;
  LastLogin: string | null = null;
  private baseUrl: string = environment.apiUrl;
  isMegaMenuOpen = false;
  constructor(
    public route: Router,
    private http: HttpClient,
    public authService: AuthServiceService,
    public common: CommonServiceService
  ) {}
  toggleMegaMenu(event: MouseEvent) {
    event.stopPropagation(); // Prevents the click event from propagating up the DOM
    this.isMegaMenuOpen = !this.isMegaMenuOpen;
  }
  @HostListener('document:click', ['$event'])
  closeMegaMenu(event: Event) {
    if (!event.target['closest']('.dropdown-mega')) {
      this.isMegaMenuOpen = false;
    }
  }
  logout() {
    this.authService.logout();
  }

  ngOnInit(): void {
    //setTimeout(()=>{},500);
    const session = this.authService.getSession();
    this.userId = session.userId;
    this.UserName = session.username;
    this.LastLogin = localStorage.getItem('LastLogin');
    const pageList = localStorage.getItem('pageList');
    if(this.userId != null && this.common.rows.length == 0 && pageList == null) {
    this.common.loadpage(this.userId);
    }else{
      this.common.rows = JSON.parse(pageList || '[]');
      this.common.categorizeData();
    }

  }
  
  // loadpage(userId: string) {
  //   const params = new HttpParams().set('UserId', userId);

  //   this.http.get<any>(this.baseUrl + '/api/Getpage', { params }).subscribe({
  //     next: (response) => {
  //       this.rows = response;
  //       this.authService.pageList = response;
  //       localStorage.setItem('pageList', JSON.stringify(this.rows));
  //       this.categorizeData();
  //     },
  //     error: (error) => {
  //       console.log(error);
  //       if(error.status == 401){
  //         this.authService.logout();
  //       }
  //     },
  //   });
  // }

  // categorizeData(): void {
  //   this.Users = [];
  //   this.Material = [];
  //   this.Service = [];
  //   this.Asset = [];
  //   this.BOM = [];
  //   this.Vendor = [];
  //   this.Customer = [];
  //   this.Datacleasning = [];
  //   this.MetaData = [];
  //   this.Settings = [];
  //   this.LOV = [];
  //   this.Tools = [];

  //   this.Admin = [];

  //   this.rows.forEach((item) => {
  //     switch (item.Module) {
  //       case 'User':
  //         this.Users.push(item);
  //         break;
  //       case 'Material':
  //         this.Material.push(item);
  //         break;
  //       case 'Service':
  //         this.Service.push(item);
  //         break;
  //       case 'Asset':
  //         this.Asset.push(item);
  //         break;
  //       case 'BOM':
  //         this.BOM.push(item);
  //         break;
  //       case 'Vendor':
  //         this.Vendor.push(item);
  //         break;
  //       case 'Customer':
  //         this.Customer.push(item);
  //         break;
  //       case 'Datacleasning':
  //         this.Datacleasning.push(item);
  //         break;
  //       case 'Admin':
  //         this.Admin.push(item);
  //         break;
  //       case 'MetaData':
  //         this.MetaData.push(item);
  //         break;
  //       case 'LOV':
  //         this.LOV.push(item);
  //         break;
  //       case 'Settings':
  //         this.Settings.push(item);
  //         break;

  //       case 'Tools':
  //         this.Tools.push(item);
  //         break;

  //       default:
  //         console.warn(`Unknown Mainmenu: ${item.Module}`);
  //         break;
  //     }
  //   });
  // }


  @Output() openIframeEvent = new EventEmitter<string>();

  onHealthCheckClick(event: Event) {
    event.preventDefault(); 
    // Emit the URL up to the parent component
    this.openIframeEvent.emit('https://swift.codasol.com/');
  }
}
